export default __webpack_public_path__ + "static/media/icon-edit.8422ecff.svg";